import React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Card } from "@material-ui/core";
import InventoryTable from "./InventoryTable";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function FullWidthTabs(props) {
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  return (
    <div className={classes.root}>
      <Card variant='outlined'>
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor='primary'
          textColor='primary'
          variant='fullWidth'
          aria-label='full width tabs example'
        >
          <Tab label=<Typography> Modules </Typography> />
          <Tab
            label=<Typography style={{ color: "#bb3737" }}>
              {" "}
              Tools 1{" "}
            </Typography>
          />
          <Tab
            label=<Typography style={{ color: "#f7ad00" }}>
              {" "}
              Tools 2{" "}
            </Typography>
          />
          <Tab
            label=<Typography style={{ color: "#147385" }}>Tools 3</Typography>
          />
          <Tab
            label=<Typography style={{ color: "#0c7853" }}>
              {" "}
              Tools 4{" "}
            </Typography>
          />
          <Tab
            label=<Typography style={{ color: "#794879" }}>
              {" "}
              Tools 5{" "}
            </Typography>
          />
        </Tabs>
      </Card>

      <TabPanel value={value} index={0} dir={theme.direction}>
        <InventoryTable user={props.user} id={"M"} isMobile={props.isMobile} />
      </TabPanel>
      <TabPanel value={value} index={1} dir={theme.direction}>
        <InventoryTable user={props.user} id={"T1"} isMobile={props.isMobile} />
      </TabPanel>
      <TabPanel value={value} index={2} dir={theme.direction}>
        <InventoryTable user={props.user} id={"T2"} isMobile={props.isMobile} />
      </TabPanel>
      <TabPanel value={value} index={3} dir={theme.direction}>
        <InventoryTable user={props.user} id={"T3"} isMobile={props.isMobile} />
      </TabPanel>
      <TabPanel value={value} index={4} dir={theme.direction}>
        <InventoryTable user={props.user} id={"T4"} isMobile={props.isMobile} />
      </TabPanel>
      <TabPanel value={value} index={5} dir={theme.direction}>
        <InventoryTable user={props.user} id={"T5"} isMobile={props.isMobile} />
      </TabPanel>
    </div>
  );
}
